import { FilterSortType } from "components/atoms/ExpandedRowTable/useExpandedRowTableForRetroClaim";

export const Filters = {
	ROLE_MANAGEMENT: [
		{
			title: "Status / Date & Time created",
			values: [
				{ id: "status-1", value: "Sort by status (Active first)" },
				{ id: "status-2", value: "Sort by status (Deactivated first)" },
				{ id: "status-3", value: "Date & Time created (Newest to Oldest)" },
				{ id: "status-4", value: "Date & Time created (Oldest to Newest)" }
			]
		},
		{
			title: "Records per page",
			values: [
				{ id: "record-1", value: "Display 5 records per page" },
				{ id: "record-2", value: "Display 10 records per page" }
			]
		}
	],
	RETRO_CLAIM: [
		{
			title: "Filter by",
			values: [
				{ id: "status-1", value: "Status (Pending first)" },
				{ id: "status-2", value: "Status (Pending Approver first)" },
				{ id: "status-3", value: "Status (Approved first)" },
				{ id: "status-4", value: "Status (Rejected first)" },
				{ id: "status-9", value: "Receipt No.", hasInput: true, filterName: "receipt", inputPlaceholder: "Enter receipt number" },
				{ id: "status-10", value: "Outlet Code (Numbers only)", hasInput: true, filterName: "outlet", inputPlaceholder: "Enter outlet code" }
			]
		},
		{
			title: "Sort by",
			values: [
				{ id: "status-5", value: "Receipt Date & Time  (Newest to Oldest)" },
				{ id: "status-6", value: "Receipt Date & Time  (Oldest to Newest)" },
				{ id: "status-7", value: "Outlet by alphabetical order (A to Z )" },
				{ id: "status-8", value: "Outlet by reverse alphabetical order (Z to A )" }
			]
		}
	],
	REIMB_CLAIM: [
		{
			title: "Date & Time / Tenant / Outlet",
			values: [
				{ id: "status-1", value: "Date & Time  (Newest to Oldest)" },
				{ id: "status-2", value: "Date & Time  (Oldest to Newest)" },
				{ id: "status-3", value: "Sort Tenant by alphabetical order (A to Z )" },
				{ id: "status-4", value: "Sort Tenant by reverse alphabetical order (Z to A )" },
				{ id: "status-5", value: "Sort Outlet by alphabetical order (A to Z )" },
				{ id: "status-6", value: "Sort Outlet by reverse alphabetical order (Z to A )" }
			]
		}
	],
	REIMB_LIST: [
		{
			title: "Transaction Date & Time / Purchase Value / eVoucher Value / eVoucher Qty & Type",
			values: [
				{ id: "status-1", value: "Transaction Date & Time (Newest to Oldest)" },
				{ id: "status-2", value: "Transaction Date & Time (Oldest to Newest)" },
				{ id: "status-5", value: "Sort By Purchase Value (Lowest to Highest)" },
				{ id: "status-6", value: "Sort By Purchase Value (Highest to Lowest)" },
				{ id: "status-7", value: "Sort By eVoucher Value (Lowest to Highest)" },
				{ id: "status-8", value: "Sort By eVoucher Value (Highest to Lowest)" },
				{ id: "status-9", value: "Sort By eVoucher Qty" },
				{ id: "status-10", value: "Sort By eVoucher Type" }
			]
		},
		{
			title: "Records per page",
			values: [
				{ id: "status-3", value: "Display 20 records per page" },
				{ id: "status-4", value: "Display 30 records per page" }
			]
		}
	],
	ACCOUNT_MANAGEMENT: [
		{
			title: "Status / Date & Time created / Last login Date & Time",
			values: [
				{ id: "status-1", value: "Sort by status (Active first)" },
				{ id: "status-2", value: "Sort by status (Deactivated first)" },
				{ id: "status-3", value: "Date & Time created (Newest to Oldest)" },
				{ id: "status-4", value: "Date & Time created (Oldest to Newest)" }
			]
		},
		{
			title: "Records per page",
			values: [
				{ id: "record-1", value: "Display 5 records per page" },
				{ id: "record-2", value: "Display 10 records per page" }
			]
		}
	]
};

export const RetroClaimFilterStatusSort: FilterSortType = {
	"Status (Pending first)": "PENDING",
	"Status (Pending Approver first)": "PENDING_APPROVAL",
	"Status (Approved first)": "APPROVED",
	"Status (Rejected first)": "REJECTED",
	"Status (Active first)": "ACTIVE",
	"Status (Deactivated first)": "DEACTIVATED"
};

export const FilterStatusSort: FilterSortType = {
	"Sort by status (Pending first)": "PENDING",
	"Sort by status (Pending Approver first)": "PENDING_APPROVAL",
	"Sort by status (Approved first)": "APPROVED",
	"Sort by status (Rejected first)": "REJECTED",
	"Sort by status (Active first)": "ACTIVE",
	"Sort by status (Deactivated first)": "DEACTIVATED"
};
